import { render, staticRenderFns } from "./SavedNotifications.vue?vue&type=template&id=2ceb22aa&scoped=true&"
import script from "./SavedNotifications.vue?vue&type=script&lang=js&"
export * from "./SavedNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SavedNotifications.vue?vue&type=style&index=0&id=2ceb22aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb22aa",
  null
  
)

export default component.exports